import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import Link from "../../components/Link";
import { getZLaunchCoin } from "../../client";
import { formatNumberToLocale } from "../../utils";

dayjs.extend(advancedFormat);

const ZLaunchDetails = ({ token }) => {
  const { ticker, name: tokenName } = token;

  const { t, siteCountry } = useContext(CustomI18nextContext);
  const [coinDetail, setCoinDetail] = useState(null);

  useEffect(() => {
    const getCoinDetail = async () => {
      const [data] = await getZLaunchCoin(siteCountry, ticker);
      if (data) {
        const earningPeriod = dayjs(data.earningEndedAt).diff(
          dayjs(data.earningStartedAt),
          "day"
        );
        const totalDailyRewards =
          Number(data.rewardTotalAmount) / earningPeriod;

        setCoinDetail({
          ...data,
          totalDailyRewards,
          totalHourlyRewards: totalDailyRewards / 24,
          isInprogress: dayjs().isBefore(data.earningEndedAt),
        });
      }
    };

    getCoinDetail();
  }, []);

  return (
    <>
      <h2>
        {t("coinInfo.projectDetail.zLaunchProjectDetails", {
          ticker,
        })}
      </h2>
      <div className="table-wrapper">
        <table>
          <tbody>
            <tr>
              <td>{t("coinInfo.projectDetail.zLaunchStartDate")}</td>
              <td>
                {coinDetail?.earningStartedAt &&
                  dayjs(coinDetail?.earningStartedAt).format("Do MMMM YYYY")}
              </td>
            </tr>
            <tr>
              <td>{t("coinInfo.projectDetail.totalTokenRewards")}</td>
              <td>
                {formatNumberToLocale(
                  coinDetail?.rewardTotalAmount,
                  siteCountry
                )}{" "}
                {coinDetail?.symbol}
              </td>
            </tr>
            <tr>
              <td>{t("coinInfo.projectDetail.totalDailyRewards")}</td>
              <td>
                {formatNumberToLocale(
                  coinDetail?.totalDailyRewards,
                  siteCountry,
                  coinDetail?.rewardProduct.decimalPlaces
                )}{" "}
                {coinDetail?.rewardProduct?.symbol}
              </td>
            </tr>
            <tr>
              <td>{t("coinInfo.projectDetail.totalHourlyRewards")}</td>
              <td>
                {formatNumberToLocale(
                  coinDetail?.totalHourlyRewards,
                  siteCountry,
                  coinDetail?.rewardProduct.decimalPlaces
                )}{" "}
                {coinDetail?.rewardProduct?.symbol}
              </td>
            </tr>
            <tr>
              <td>{t("coinInfo.projectDetail.projectMaximumLockLimit")}</td>
              <td>
                {formatNumberToLocale(coinDetail?.poolCapAmount, siteCountry)}{" "}
                {coinDetail?.poolLockProduct?.symbol}
              </td>
            </tr>
            <tr>
              <td>{t("coinInfo.projectDetail.userMaximumLockLimit")}</td>
              <td>
                {formatNumberToLocale(coinDetail?.userCapAmount, siteCountry)}{" "}
                {coinDetail?.poolLockProduct?.symbol}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {coinDetail?.isInprogress && (
        <div className="d-flex justify-content-center">
          <Link
            className="lock-to-farm__btn button button-primary text-center"
            to={`${t("common.exchangeLink")}/earn/zlaunch/ `}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("coinInfo.projectDetail.lockToFarm", { tokenName })}
          </Link>
        </div>
      )}

      <div className="zlaunch-details__note d-flex flex-column flex-sm-row p-4">
        <strong className="mr-2">{t("coinInfo.projectDetail.note")}</strong>
        <div>
          <p>{t("coinInfo.projectDetail.noteProjectMaximumLockLimit")}</p>
          <p className="mb-0">
            {t("coinInfo.projectDetail.noteUserMaximumLockLimit")}
          </p>
        </div>
      </div>
    </>
  );
};

ZLaunchDetails.propTypes = {
  token: PropTypes.shape({
    ticker: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ZLaunchDetails;
